import { gql } from "@apollo/client";
export const CREATE_FEATURED_ADS = gql`
  mutation CreateFeaturedAd($input: CreateFeaturedAdInput) {
    createFeaturedAd(input: $input) {
      data {
            featuredAd {
                identifier
                name
                featured_type
                featured_order
                video
                created_at
                image
                upload_status
                updated_at
                id
                status
            }
        }
        error {
            message
            code
            field
        }
    }
  }
`;

export const UPDATE_FEATURED_ADS = gql`
  mutation UpdateFeaturedAd($input: CreateFeaturedAdInput, $ad_id: UUID!) {
    updateFeaturedAd(ad_id: $ad_id, input: $input) {
      data {
            featuredAd {
                name
                featured_type
                featured_order
                identifier
                created_at
                image
                upload_status
                updated_at
                id
                status
                video
            }
        }
        error {
            message
            code
            field
        }
    }
  }
`;
export const UPLOAD_FEATURED_ADS_VIDEO = gql`
  mutation UploadFeaturedVideo(
    $title: String
    $folder_id: String
    $create_video_id: UUID
  ) {
    uploadFeaturedVideo(
      title: $title
      folder_id: $folder_id
      create_video_id: $create_video_id
    ) {
      data {
        client_playload {
          uploadLink
          video_id
          policy
          key
          x_amz_signature
          x_amz_algorithm
          x_amz_date
          x_amz_credential
        }
      }
      error {
        message
        code
        field
      }
    }
  }
`;


export const DELETE_FEATURED_ADS = gql`
  mutation DeleteFeaturedAd($ad_id: UUID!) {
    deleteFeaturedAd(ad_id: $ad_id) {
      data {
        message
      }
      error {
        code
        field
        message
      }
    }
  }
`;
